import React, { FC } from 'react';

import { TextProps } from '@rbilabs/universal-components';

import SanityBlockRenderer from 'components/sanity-block-renderer';

import { INutritionDisclaimer } from '../types';

const paragraphStyles: TextProps = {
  variant: 'copyTwo',
  textAlign: 'left',
  fontSize: 'xs',
  marginBottom: '$4',
};

// TODO - RN: Variant styles do not apply to SanityBlockRenderer links
const linkStyles: TextProps = {
  variant: 'copyTwo',
  fontSize: 'xs',
  textDecorationLine: 'underline',
  color: `${Styles.color.black}`,
};

export const NutritionDisclaimer: FC<INutritionDisclaimer> = ({ content }) => (
  <SanityBlockRenderer
    testID="nutrition-disclaimer"
    content={content}
    textProps={paragraphStyles}
    linkProps={linkStyles}
    focusable
  />
);
